import type { RecentFlightSearches } from '@/components/TripActivity/types'
import { format } from 'date-fns/format'
import { parse } from 'date-fns/parse'
import { FLY_CABIN_CLASS } from '../constants'

const ORIGINAL_DATE_FORMAT = 'yyyy-MM-dd'
const LONG_DATE_FORMAT = 'EEE, LLL dd, yyyy'
const SHORT_DATE_FORMAT = 'yyyyMMdd'

export default function transformRecentSearchTripData(
  mostRecentFlightSearchData: ReadonlyArray<RecentFlightSearches>,
) {
  const {
    originAirportInfo,
    destinationAirportInfo,
    tripType,
    travelStartDate,
    travelEndDate,
    cabinClass,
    numberOfAdults,
    numberOfChildren,
    listingsUrl,
  } = mostRecentFlightSearchData[0]

  const { city: originCity, state: originState, code: originCityCode, name: originName } = originAirportInfo
  const {
    city: destinationCity,
    state: destinationState,
    code: destinationCityCode,
    name: destinationName,
  } = destinationAirportInfo

  const isRoundTrip = tripType === 'ROUND_TRIP'
  const subheadline = isRoundTrip ? 'Round trip' : 'One way'

  const startDateLongFormat = format(
    parse(travelStartDate, ORIGINAL_DATE_FORMAT, new Date()),
    LONG_DATE_FORMAT,
  )

  const startDateShortFormat = format(
    parse(travelStartDate, ORIGINAL_DATE_FORMAT, new Date()),
    SHORT_DATE_FORMAT,
  )

  const endDateLongFormat = isRoundTrip
    ? format(parse(travelEndDate, ORIGINAL_DATE_FORMAT, new Date()), LONG_DATE_FORMAT)
    : undefined

  const endDateShortFormat = isRoundTrip
    ? format(parse(travelEndDate, ORIGINAL_DATE_FORMAT, new Date()), SHORT_DATE_FORMAT)
    : undefined

  const flyTravelersCount = {
    adultCount: numberOfAdults,
    childCount: numberOfChildren,
  }

  const searchData = {
    subheadline,
    startDateLongFormat,
    startDateShortFormat,
    endDateLongFormat,
    endDateShortFormat,
    originState: originState || '',
    originCity: originCity || originName,
    originCityCode,
    destinationState: destinationState || '',
    destinationCity: destinationCity || destinationName,
    destinationCityCode,
    flyTravelersCount,
    cabinClass: FLY_CABIN_CLASS[cabinClass],
    listingsUrl,
  } as const

  return searchData
}
